// extracted by mini-css-extract-plugin
module.exports = {"custom_select":"Select_custom_select__XmR4G","custom_select_arrow":"Select_custom_select_arrow__2rV_A","custom_select_dropdown":"Select_custom_select_dropdown__1GW7S"};